export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сбросить"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбрать все"])}
}